var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',_vm._g(_vm._b({class:_vm.cellValue.class},'td',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.cellValue.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }